import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { dripKeys, contactKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useTestEnrollDrip = () => {
    const additional = useQueryRequestParams();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (body) => axios.post(markUrl('drips/test/enroll/'), body, additional),
        onSuccess: (_response, vars) => {
            queryClient.invalidateQueries({ queryKey: dripKeys.statsRoot(vars.drip_id) });
            queryClient.invalidateQueries({ queryKey: contactKeys.detail(vars.profile_id) });
            queryClient.invalidateQueries({
                queryKey: contactKeys.engagementRoot(vars.profile_id)
            });
        }
    });
};
export default useTestEnrollDrip;
